import { render } from "./AnnotationCard.vue?vue&type=template&id=d554ea88&ts=true"
import script from "./AnnotationCard.vue?vue&type=script&lang=ts"
export * from "./AnnotationCard.vue?vue&type=script&lang=ts"

import "./AnnotationCard.vue?vue&type=style&index=0&id=d554ea88&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__